import type { InjectionKey } from 'vue'

export type ButtonColor = 'brand' | 'error' | 'gray' | 'purple'
export type ButtonVariant = 'primary' | 'secondary' | 'table' | 'tertiary' | 'text'
export type ButtonGroupDefaults = { color?: ButtonColor; variant?: ButtonVariant }
export const buttonGroupKey: InjectionKey<ButtonGroupDefaults> = Symbol('ui-button-group')
